/**
 * Love Store Paris — Page d'accueil (Phase 4)
 */
(function () {
  'use strict';

  function parseCountdownEnd(value) {
    if (!value) return NaN;
    var normalized = String(value).trim().replace(' ', 'T');
    return Date.parse(normalized);
  }

  function initCountdownElement(countdown) {
    if (!countdown || countdown.dataset.lspCountdownInit === 'true') return;
    countdown.dataset.lspCountdownInit = 'true';

    function tick() {
      var end = parseCountdownEnd(countdown.getAttribute('data-countdown-end'));
      if (isNaN(end)) return;
      var total = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var days = Math.floor(total / 86400);
      var hours = Math.floor((total % 86400) / 3600);
      var mins = Math.floor((total % 3600) / 60);
      var secs = total % 60;

      countdown.querySelectorAll('[data-unit]').forEach(function (el) {
        var key = el.getAttribute('data-unit');
        var val = 0;
        if (key === 'days') val = days;
        if (key === 'hours') val = hours;
        if (key === 'minutes') val = mins;
        if (key === 'seconds') val = secs;
        el.textContent = String(val).padStart(2, '0');
      });
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function initCountdownsIn(root) {
    var scope = root || document;
    if (scope.hasAttribute && scope.hasAttribute('data-lsp-countdown')) {
      initCountdownElement(scope);
      return;
    }
    scope.querySelectorAll('[data-lsp-countdown]').forEach(initCountdownElement);
  }

  function initHeroCarousel(root) {
    if (!root || root.dataset.lspHeroInit === 'true') return;
    root.dataset.lspHeroInit = 'true';

    var slides = root.querySelectorAll('[data-lsp-hero-slide]');
    if (!slides.length) return;

    slides.forEach(function (slide, i) {
      slide.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
    });

    var dots = root.querySelectorAll('[data-lsp-hero-dot]');
    var current = 0;
    var fading = false;
    var intervalMs = parseInt(root.dataset.autoplayMs, 10) || 5000;
    var timer = null;

    var badgeIcons = {
      bolt: '<span class="lsp-home-hero-carousel__badge-icon lsp-home-hero-carousel__badge-icon--bolt" data-lsp-hero-badge-icon aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg></span>',
      whatsapp: '<span class="lsp-home-hero-carousel__badge-icon lsp-home-hero-carousel__badge-icon--whatsapp" data-lsp-hero-badge-icon aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.881 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg></span>',
      vip: '<span class="lsp-home-hero-carousel__badge-icon lsp-home-hero-carousel__badge-icon--vip" data-lsp-hero-badge-icon aria-hidden="true">✦</span>'
    };

    function updateBadge(slide) {
      var badge = root.querySelector('[data-lsp-hero-badge]');
      if (!badge || !slide) return;

      var badgeText = slide.getAttribute('data-badge-label');
      var badgeIcon = slide.getAttribute('data-badge-icon') || 'bolt';
      var labelEl = badge.querySelector('[data-lsp-hero-badge-label]');
      var iconEl = badge.querySelector('[data-lsp-hero-badge-icon]');

      if (labelEl && badgeText) labelEl.textContent = badgeText;

      if (iconEl && badgeIcons[badgeIcon]) {
        var wrap = document.createElement('span');
        wrap.innerHTML = badgeIcons[badgeIcon];
        var nextIcon = wrap.firstElementChild;
        if (nextIcon) iconEl.replaceWith(nextIcon);
      }

      badge.setAttribute('data-badge-icon', badgeIcon);
    }

    function setActive(index) {
      if (fading || index === current) return;
      fading = true;
      slides[current].classList.add('is-fading');
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');

      window.setTimeout(function () {
        slides[current].classList.remove('is-fading');
        current = index;
        slides[current].classList.add('is-active');
        slides[current].setAttribute('aria-hidden', 'false');
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === current);
          dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
        });
        updateBadge(slides[current]);
        fading = false;
      }, 300);
    }

    function next() {
      setActive((current + 1) % slides.length);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-lsp-hero-dot'), 10);
        if (!isNaN(index)) setActive(index);
      });
    });

    if (root.dataset.autoplay !== 'false') {
      timer = window.setInterval(next, intervalMs);
      root.addEventListener('mouseenter', function () {
        if (timer) window.clearInterval(timer);
      });
      root.addEventListener('mouseleave', function () {
        if (timer) window.clearInterval(timer);
        timer = window.setInterval(next, intervalMs);
      });
    }

    initCountdownsIn(root);
  }

  function scrollCarousel(track, direction, itemSelector) {
    if (!track) return;
    var selector = itemSelector || '.lsp-home-carousel__item';
    var item = track.querySelector(selector);
    if (!item) return;
    var gap = parseFloat(getComputedStyle(track).gap) || 16;
    track.scrollBy({ left: direction * (item.offsetWidth + gap), behavior: 'smooth' });
  }

  function initCartForms(root) {
    root.querySelectorAll('[data-type="add-to-cart-form"]').forEach(function (form) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput) idInput.disabled = false;
    });
  }

  function initDiscoverRail(root) {
    if (!root || root.dataset.lspDiscoverInit === 'true') return;
    root.dataset.lspDiscoverInit = 'true';

    var track = root.querySelector('[data-lsp-discover-track]');
    var prev = root.querySelector('[data-lsp-discover-prev]');
    var next = root.querySelector('[data-lsp-discover-next]');

    if (prev) prev.addEventListener('click', function () { scrollCarousel(track, -1, '.lsp-home-hero-discover__item'); });
    if (next) next.addEventListener('click', function () { scrollCarousel(track, 1, '.lsp-home-hero-discover__item'); });
  }

  function initProductCarousel(root) {
    if (!root || root.dataset.lspCarouselInit === 'true') return;
    root.dataset.lspCarouselInit = 'true';

    initCartForms(root);

    var track = root.querySelector('[data-lsp-carousel-track]');
    var prev = root.querySelector('[data-lsp-carousel-prev]');
    var next = root.querySelector('[data-lsp-carousel-next]');

    if (prev) prev.addEventListener('click', function () { scrollCarousel(track, -1); });
    if (next) next.addEventListener('click', function () { scrollCarousel(track, 1); });
  }

  function initHome(root) {
    if (!root) return;
    root.querySelectorAll('[data-lsp-hero-carousel]').forEach(initHeroCarousel);
    root.querySelectorAll('[data-lsp-hero-discover]').forEach(initDiscoverRail);
    root.querySelectorAll('[data-lsp-home-carousel]').forEach(initProductCarousel);
    initCountdownsIn(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lsp-home]').forEach(initHome);
    document.querySelectorAll('[data-lsp-hero-carousel]').forEach(initHeroCarousel);
    document.querySelectorAll('[data-lsp-hero-discover]').forEach(initDiscoverRail);
    document.querySelectorAll('[data-lsp-home-carousel]').forEach(initProductCarousel);
    initCountdownsIn(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initHome(e.target);
    initCountdownsIn(e.target);
  });
})();
